/* istanbul ignore file */
import type { IPalette } from '../colors';
import { TeamsMeetingColors } from '../colors/teamsMeetingPalette';
import { TeamsColors } from '../colors/teamsPalette';
import { NeutralColors } from '../colors/yammerPalette';

import { createCustomizedThemeWithSlotOverrides } from './createCustomizedThemeWithSlotOverrides';
import { defaultDarkTheme, defaultTheme } from './default';
import { teamsDarkTheme, teamsTheme } from './teams';
import type { ITheme } from './theme.types';

// Before editing these colors consider if it can be shared with the Teams Communities app.
// Colors and palettes are inherited from yammer-web-core-ui/src/util/theme/teams.ts
const themeColors: Partial<IPalette> = {
  greenLight: TeamsMeetingColors.green300,
  green: TeamsMeetingColors.green400,
  greenDark: TeamsMeetingColors.green600,
};

export const teamsMeetingTheme: ITheme = createCustomizedThemeWithSlotOverrides({
  name: 'yammerTeamsMeeting',
  theme: defaultTheme,
  paletteOverrides: { ...teamsTheme.palette, ...themeColors },
  semanticColorOverrides: {
    ...teamsTheme.semanticColors,
    infoBackground: 'transparent',
  },
});

export const teamsMeetingUpdatedTheme: ITheme = createCustomizedThemeWithSlotOverrides({
  name: 'yammerTeamsMeetingUpdated',
  theme: teamsMeetingTheme,
  semanticColorOverrides: {
    ...teamsMeetingTheme.semanticColors,
    bodyBackground: NeutralColors.white,
  },
  fontOverrides: teamsMeetingTheme.fonts,
});

export const teamsMeetingDarkTheme: ITheme = createCustomizedThemeWithSlotOverrides({
  name: 'yammerTeamsMeetingDark',
  theme: defaultDarkTheme,
  paletteOverrides: { ...teamsDarkTheme.palette, ...themeColors },
  semanticColorOverrides: {
    ...teamsDarkTheme.semanticColors,
    infoBackground: 'transparent',
    primaryButtonText: NeutralColors.white,
    primaryButtonBackground: TeamsColors.brand600,
    primaryButtonTextDisabled: NeutralColors.gray100,
  },
  fontOverrides: teamsMeetingTheme.fonts,
});
